<script setup lang="ts">
import { SelectIcon, SelectTrigger, type SelectTriggerProps } from 'radix-vue';
import { ChevronDown } from 'lucide-vue-next';
import { cn } from '../lib/utils';
import { useFormField } from '../form/useFormField';

const props = withDefaults(
  defineProps<SelectTriggerProps & { class?: string }>(),
  {
    class: '',
  },
);

const { error } = useFormField();

</script>

<template>
  <SelectTrigger
    v-bind="props"
    :class="[
      cn(`
      inline-flex min-h-[40px] w-full items-center justify-between border px-[12px] py-[8px] text-sm
      outline-none focus:border-[color:var(--input-active-border)]
      disabled:cursor-not-allowed disabled:opacity-50 border-[color:var(--input-primary-border)]
      text-left text-[color:var(--theme-heading-color)]
      [&>span]:min-w-0 [&>span]:whitespace-normal [&>span]:break-words [&>span]:text-left`,
         props.class,
      ),
      error && 'border-[color:var(--theme-highlight-color)]',
    ]"
  >
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="h-full" />
    </SelectIcon>
  </SelectTrigger>
</template>
